// Generated by AI on 06/09/2026
// Modified by AI on 06/10/2026. Edit #1.
/**
 * Centralized React Query key definitions and time constants for cache management
 */

// Time constants in milliseconds
export const FIVE_MINUTES_MS = 5 * 60 * 1000;
export const TEN_MINUTES_MS = 10 * 60 * 1000;
export const THIRTY_MINUTES_MS = 30 * 60 * 1000;

export const QUERY_KEYS = {
    staticData: ['staticData'],
    publicEmailDomains: ['publicEmailDomains'],
    theme: (publicRouteKey, employerId, colorScheme, colorSchemeSettings, resellerEmployerId, globalColorSchemeSettings) => [
        'theme',
        publicRouteKey,
        employerId,
        colorScheme,
        colorSchemeSettings,
        resellerEmployerId,
        globalColorSchemeSettings,
    ],
    linkedinUserInviteLimit: (userLinkedinId, weeklyLimit) => [
        'linkedinUserInviteLimit',
        userLinkedinId,
        weeklyLimit,
    ],
    tpaHealthMeter: (positionId, filter) => [
        'tpaHealthMeter',
        positionId,
        filter,
    ],
    // Base keys for invalidation (matches all queries with this prefix)
    tpaHealthMeterBase: (positionId) => ['tpaHealthMeter', positionId],
    // Settings query keys
    settings: {
        config: ['settings', 'config'],
        preferences: ['settings', 'preferences'],
        positionCriteria: ['settings', 'positionCriteria'],
        fastRatingCriteria: ['settings', 'fastRatingCriteria'],
        gdprLocations: ['settings', 'gdprLocations'],
        translatedCountries: ['settings', 'translatedCountries'],
    },
    // Modified by AI on 06/12/2026. Edit #2.
    // Campaign query keys
    campaign: {
        byPosition: (positionId) => ['campaign', 'byPosition', positionId],
        byId: (campaignId) => ['campaign', 'byId', campaignId],
        autoContactAvailability: (positionId, workflowStep) => ['campaign', 'autoContactAvailability', positionId, workflowStep],
    },
    // Modified by AI on 06/12/2026. Edit #3.
    // AutoCampaign query keys
    autoCampaign: (positionId) => ['autoCampaign', positionId],
    // Modified by AI on 06/12/2026. Edit #4.
    // Employer query keys
    employer: (employerId) => ['employer', employerId],
    reseller: (employerId) => ['reseller', employerId],
    // Modified by AI on 06/12/2026. Edit #5.
    // Position query keys
    position: (positionId) => ['position', positionId],
    // Modified by AI on 06/24/2026. Edit #6.
    // Recruiter query keys
    recruiter: (recruiterId) => ['recruiter', recruiterId],
    // Modified by AI on 06/24/2026. Edit #7.
    // Employer workflow query keys
    workflow: {
        itemsData: (positionId, employerId) => ['workflow', 'itemsData', positionId, employerId],
    },
    // Modified by AI on 06/24/2026. Edit #8.
    // Explain query keys
    explain: {
        candidates: (positionId, talentIdsKey, isSamples) => ['explain', 'candidates', positionId, talentIdsKey, !!isSamples],
    },
    // Modified by AI on 06/24/2026. Edit #9.
    // Candidates LinkedIn status query keys
    candidatesContactData: (positionId, talentIdsKey) => ['candidatesContactData', positionId, talentIdsKey],
};
